<payee-popup title="Opcionális és díj követelések szerkesztése">
  <div id="case-details">
    <h2>Ügy adatai</h2>
    <ul class="flex column">
      <li>Iktatószám: {{ data.payee_case_reference_id }}</li>
      @for (currency of claimSums | keyvalue; track currency.key) {
        <li>
          <div>
            Eredeti Tőkekövetelés:
            {{ currency.value.original_amount | number: "1.0" : "hu" }}
            {{ currency.key }}
          </div>
          <div>
            Fennálló Tőkekövetelés:
            {{ currency.value.remaining_amount | number: "1.0" : "hu" }}
            {{ currency.key }}
          </div>
        </li>
      }
    </ul>
  </div>
  @if (!loading()) {
    <div
      class="form-content"
      [class.is-submitting]="submitting()"
      [attr.aria-busy]="submitting()"
    >
      <form
        class="top-margin-10"
        [formGroup]="form"
      >
        <mat-checkbox [formControl]="interest_claim_added">Kamatok érvényesítése</mat-checkbox>
        <mat-checkbox [formControl]="flat_rate_cost_claims_added">40 EUR átalány érvényesítése</mat-checkbox>

        <div class="fee-section">
          <h2>Ügyindítási díj</h2>
          <mat-checkbox [formControl]="payee_fee_claim_added">Ügyindítási díj érvényesítése</mat-checkbox>
          @if (payeeFeeClaim !== null && payeeFeeClaim.original_amount !== null) {
            <p class="fee-amount">{{ payeeFeeClaim.original_amount | number: "1.0" : "hu" }} HUF</p>
          }
        </div>

        <div class="fee-section">
          <h2>Közjegyzői eljárási díj</h2>
          <mat-checkbox [formControl]="procedural_fee_claim_added">Közjegyzői eljárási díj érvényesítése</mat-checkbox>
          @if (proceduralFeeClaim !== null && proceduralFeeClaim.original_amount !== null) {
            <p class="fee-amount">{{ proceduralFeeClaim.original_amount | number: "1.0" : "hu" }} HUF</p>
          }
        </div>
      </form>

      @if (submitting()) {
        <div class="submitting-overlay">
          <mat-progress-spinner
            mode="indeterminate"
            color="accent"
          ></mat-progress-spinner>
        </div>
      }
    </div>
  } @else {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [loading]="submitting()"
      [disabled]="submitting() || loading()"
      (click)="submit()"
    >
      Mentés
    </button>
  </ng-template>
  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="alert-red"
      width="max"
      [disabled]="submitting()"
      (click)="cancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
